import { Link } from "react-router-dom";

const SECTIONS = [
  {
    title: "Éditeur du site",
    body: [
      "Le site est édité par Présence Home Services — Carole Bourbasquet, Entrepreneur individuel.",
      "Numéro SIRET : 533 909 818 00015",
      "Adresse : U Centru, Route de Bastia, 20137 Porto-Vecchio, Corse-du-Sud, France",
      "E-mail : caropv2a@gmail.com — Téléphone : +33 6 03 27 46 10",
    ],
  },
  {
    title: "Directrice de la publication",
    body: ["La directrice de la publication est Carole Bourbasquet, gérante de Présence Home Services."],
  },
  {
    title: "Conception et réalisation",
    body: [
      "Le site a été conçu et créé par l'agence THE HILL PROJECT — www.thehillproject.fr",
    ],
  },
  {
    title: "Hébergement",
    body: ["L'hébergement du site est assuré par OVH — 2 rue Kellermann, 59100 Roubaix, France."],
  },
  {
    title: "Propriété intellectuelle",
    body: [
      "L'ensemble des contenus présents sur ce site (textes, photographies, logo, identité visuelle) est la propriété exclusive de Présence Home Services ou de ses partenaires, sauf mention contraire.",
      "Toute reproduction, représentation ou diffusion, totale ou partielle, sans autorisation écrite préalable est interdite.",
    ],
  },
  {
    title: "Liens hypertextes",
    body: [
      "Le site peut contenir des liens vers des sites tiers. Présence Home Services ne saurait être tenue responsable du contenu de ces sites externes.",
    ],
  },
  {
    title: "Crédits photographiques",
    body: [
      "Photographies : Margot Bourbasquet — Agence THE HILL PROJECT.",
      "Les photographies présentes sur ce site ne sont pas libres de droits et appartiennent à PRESENCE HOME SERVICES. Toute utilisation, reproduction ou diffusion sans autorisation écrite préalable est interdite.",
    ],
  },
];

export default function LegalNotice() {
  return (
    <main data-testid="legal-notice-page" className="min-h-screen px-5 pb-24 pt-32 sm:px-8 sm:pt-40">
      <div className="mx-auto max-w-3xl">
        <p className="eyebrow">Presence Home Services</p>
        <h1 className="mt-4 font-serif text-4xl sm:text-5xl text-maquis-deep">Mentions légales</h1>
        <div className="mt-12 space-y-10">
          {SECTIONS.map((s) => (
            <section key={s.title} data-testid={`legal-section-${s.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
              <h2 className="font-serif text-2xl text-maquis-deep">{s.title}</h2>
              <div className="mt-3 space-y-2 text-sm sm:text-base leading-relaxed text-maquis-olive">
                {s.body.map((p, i) => (
                  <p key={i}>{p}</p>
                ))}
              </div>
            </section>
          ))}
        </div>
        <p className="mt-14 text-sm text-maquis-soft">
          <Link to="/politique-de-confidentialite" data-testid="legal-privacy-link" className="underline decoration-sable underline-offset-4 hover:decoration-maquis-olive transition-colors">
            Consulter la politique de confidentialité
          </Link>
        </p>
      </div>
    </main>
  );
}
